import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../locales/i18n';
import { creditFormValidations } from '../form';

export const useCreditFormValidations = (type) => {
  const isEn = i18n.language !== 'ko';
  const validations = useMemo(() => {
    const baseValidations = creditFormValidations(isEn);
    const typeValidations = {};

    if (type === 'issue') {
      typeValidations.name = baseValidations.name;
      typeValidations.phone = baseValidations.phone;
      typeValidations.email = baseValidations.email;
      typeValidations.team = baseValidations.team;
      typeValidations.reductionCertSeq = baseValidations.reductionCertSeq;
    } else if (type === 'move') {
      typeValidations.name = baseValidations.name;
      typeValidations.phone = baseValidations.phone;
      typeValidations.email = baseValidations.email;
      typeValidations.team = baseValidations.team;
      typeValidations.assignorName = baseValidations.assignorName;
      typeValidations.assignorPhone = baseValidations.assignorPhone;
      typeValidations.assignorEmail = baseValidations.assignorEmail;
      typeValidations.assigneeUserSeq = baseValidations.assigneeUserSeq;
      typeValidations.assigneeName = baseValidations.assigneeName;
      typeValidations.assigneePhone = baseValidations.assigneePhone;
      typeValidations.assigneeEmail = baseValidations.assigneeEmail;
      typeValidations.projectSeq = baseValidations.projectSeq;
      typeValidations.amount = baseValidations.amount;
      typeValidations.reason = baseValidations.reason;
    } else if (type === 'offset' || type === 'retire') {
      typeValidations.name = baseValidations.name;
      typeValidations.phone = baseValidations.phone;
      typeValidations.email = baseValidations.email;
      typeValidations.team = baseValidations.team;
      typeValidations.projectSeq = baseValidations.projectSeq;
      typeValidations.amount = baseValidations.amount;
      typeValidations.reason = baseValidations.reason;
    }

    return typeValidations;
  }, [type, isEn]);

  return validations;
};

export const useReasonMenus = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      { value: t('OVER_TRANSACTION'), label: t('OVER_TRANSACTION') },
      { value: t('BIZ_TRANSFER'), label: t('BIZ_TRANSFER') },
      { value: t('BIZ_PARTICIPATION'), label: t('BIZ_PARTICIPATION') },
      { value: t('BIZ_MERGERS'), label: t('BIZ_MERGERS') },
      { value: t('DIRECT_INPUT_SPACE'), label: t('DIRECT_INPUT_SPACE') },
      { value: t('VOLUNTARY_CONTRIBUTION'), label: t('VOLUNTARY_CONTRIBUTION') },
    ],
    [t],
  );
};

